import type { ProductsReferential } from 'models/productsReferential';

type ProductsReferentialLoadingStatus = 'not_yet_loaded' | 'loaded' | 'empty' | 'loading_failed';

export type ProductsReferentialState = ProductsReferential & {
  status: ProductsReferentialLoadingStatus;
};

export const initialProductsReferentialState: ProductsReferentialState = {
  static: [],
  batch: [],
  dynamic: [],
  essential: [],
  availableAssetTypes: [],
  status: 'not_yet_loaded',
};
